import React, { useEffect, useState } from "react";
import {
  DESKTOP_PROTOCOL,
  cleanDesktopCallbackAddressBar,
  describeDesktopCallback,
  readDesktopCallbackParams,
} from "../utils/desktopCallback";
import "../styles/authSurface.css";
import "../styles/DesktopCallback.css";

const COPY = {
  opening: {
    title: "Opening Task Mantis…",
    text: "If nothing happens, use the button below.",
  },
  denied: {
    title: "Connection cancelled",
    text: "Return to Task Mantis to try again.",
  },
  missing: {
    title: "This link has already been used",
    text: "Return to Task Mantis and start the connection again.",
  },
};

/**
 * Browser-only landing page for the end of a desktop OAuth flow
 * (`/desktop-callback`). Reads the one-time code, removes it from the address
 * bar, then opens the desktop app with the `taskmantis://` link.
 *
 * @example
 * <Route path="/desktop-callback" element={<DesktopCallback />} />
 */
const DesktopCallback = () => {
  // Read once: the address bar is cleaned right after mount.
  const [{ kind, deepLink }] = useState(() =>
    describeDesktopCallback(readDesktopCallbackParams(window.location.search))
  );

  useEffect(() => {
    cleanDesktopCallbackAddressBar();
    if (deepLink) {
      window.location.href = deepLink;
    }
  }, [deepLink]);

  const copy = COPY[kind];
  // With no payload the button just brings the app to the front.
  const openLink = deepLink || `${DESKTOP_PROTOCOL}://oauth-callback`;
  return (
    <div className="desktop-callback auth-surface">
      <div className="desktop-callback__card" role="status">
        <p className="desktop-callback__brand">Task Mantis</p>
        <h1 className="desktop-callback__title">{copy.title}</h1>
        <p className="desktop-callback__text">{copy.text}</p>
        <button
          type="button"
          className="desktop-callback__button"
          onClick={() => {
            window.location.href = openLink;
          }}
        >
          Open Task Mantis
        </button>
      </div>
    </div>
  );
};

export default DesktopCallback;
